import { repository } from '@/api/base'

export default {
  async findAll() {
    const { data } = await repository.get('/studyCalendar/findAll')
    return data
  },

  async findById(id) {
    const { data } = await repository.get(`/studyCalendar/${id}`)
    return data
  },

  async create(body) {
    const { data } = await repository.post('/studyCalendar', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put('/studyCalendar', body)
    return data
  },

  async delete(id) {
    const { data } = await repository.delete(`/studyCalendar/${id}`)
    return data
  },

  async addHoliday(holiday) {
    const { data } = await repository.post(`/holiday`, holiday)
    return data
  },

  async getAllHoliday() {
    const { data } = await repository.get(`/holiday`)
    return data
  },

  async updateHoliday(holiday) {
    const { data } = await repository.put(`/holiday`, holiday)
    return data
  },

  async deleteHoliday(holidayId) {
    const { data } = await repository.delete(`/holiday/${holidayId}`)
    return data
  }
}
